import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Elements } from '@stripe/react-stripe-js';
import { BrowserRouter } from 'react-router-dom';

import { BooksProvider } from './contexts/books.context';
import { CartProvider } from './contexts/cart.context';
import { stripePromise , stripeOptions } from './utils/stripe/stripe.utils';

import Footer from './components/footer/footer.component';


import App from './App';

import './index.scss';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
		
			<BrowserRouter>
				<BooksProvider>
					<CartProvider>
						<Elements stripe={stripePromise} options={stripeOptions}>
						<div id="content">
							<App />
						</div>
						<Footer></Footer>
						</Elements>
					</CartProvider>
				</BooksProvider>
			
			</BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
